






















import { Component, Prop, Mixins} from "vue-property-decorator";
import UserMixin from '../../../mixins/UserMixin';
import UserIcon from "../../common/UserIcon.vue";
import { UserProfile } from "@api/models/UserProfile";

@Component({
    components: {UserIcon}
})
export default class SearchUser  extends Mixins(UserMixin) {
    @Prop() list: UserProfile[];

    get isSelected(): boolean {
        return !!this.list.find(item => item.userId == this.user.userId);
    }
}
